import { Skeleton, Text } from '@mantine/core';
import { IconAt, IconExternalLink } from '@tabler/icons';
import validator from 'validator';
import BookitupTextInput from '../../../Atoms/inputs/BookitupTextInput';
import { useEmailAccountingConfig } from '../../../Service/hooks/useEmailAccountingConfig';
import PanePaper from '../../../Molecules/PanePaper';

const DatevConfig = () => {
  const { loading, config, email, update } = useEmailAccountingConfig();
  const URL = 'https://datev.readyplace.net/public/tutorial/5fbce7ae212129006ede3d12?op=start';

  return (
    <PanePaper title="Rechnung per E-Mail importieren">
      {loading && <Skeleton height={40} width={600} />}
      {config && (
        <>
          <BookitupTextInput
            icon={<IconAt size={20} />}
            placeholder="deine-id@uploadmail.datev.de"
            label="E-Mail"
            defaultValue={email ?? undefined}
            type="email"
            onBlurSave={update}
            validate={validator.isEmail}
            errorMessage="Die E-Mail-Adresse ist ungültig."
            sx={{ maxWidth: 600 }}
          />
          <Text mt="xs">
            Unter folgender URL findest du ein Klick-Tutorial, wie du die E-Mail-Adresse von DATEV Unternehmen Online bekommst, um Rechnungen zu importieren:
            <Text variant="link" color="blue" mt={5} sx={{}}>
              <IconExternalLink style={{ marginBottom: 4, marginRight: 4 }} size={16} />
              <a target="_blank" href={URL} style={{ color: '#1D5191' }}>
                {URL}
              </a>
            </Text>
          </Text>
        </>
      )}
    </PanePaper>
  );
};

export default DatevConfig;
